import {
  Component,
  HostListener,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { BoobleModalService } from 'booble-modal';
import { NotifierService } from 'angular-notifier';
import { AddBankAccountComponent } from '../../modals/add-bank-account/add-bank-account.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { GenericBottomSheetComponent } from 'src/app/shared/components/generic-bottom-sheet/generic-bottom-sheet.component';
import { BankAccountService } from 'src/app/shared/services/bank-account.service';
import { BankAccountDto } from 'src/app/domain/models/dto/bank-account.dto';
import { firstValueFrom } from 'rxjs';
import { BankDashDto } from 'src/app/domain/models/dto/bank.dto';

@Component({
  selector: 'app-company-accounts',
  templateUrl: './company-accounts.component.html',
  styleUrls: ['./company-accounts.component.scss'],
})
export class CompanyAccountsComponent implements OnInit {
  isMobile: boolean = false;
  loading: boolean = false;
  banks: BankDashDto[] = [];
  private readonly notifier: NotifierService;

  @ViewChild('bottomSheetContent') bottomSheetContent: TemplateRef<any>;

  bankAccounts: BankAccountDto[] = [];

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkWindowSize();
  }

  constructor(
    private modalService: BoobleModalService,
    private bottomSheet: MatBottomSheet,
    notifierService: NotifierService,
    private bankAccountService: BankAccountService
  ) {
    this.notifier = notifierService;

    firstValueFrom(this.bankAccountService.getNewBanks()).then((banksList) => {
      this.banks = banksList.data.map((bank) => ({
        ...bank,
        name: bank.name.trim(),
        code: bank.code.trim(),
      }));

      this.bankAccountService.listenerUpdate.subscribe(() => {
        this.getBankAccounts();
      });
    });
  }

  ngOnInit() {
    this.checkWindowSize();
  }

  getBankAccounts() {
    this.bankAccountService.getAll().subscribe((getResult) => {
      getResult.data.sort((a, b) =>
        a.isDefault === b.isDefault ? 0 : a.isDefault ? -1 : 1
      );

      this.bankAccounts = getResult.data.map((bankAccount) => {
        const bank = this.banks.find((b) => b.name === bankAccount.name.trim());
        return {
          ...bankAccount,
          bank: bank ? `${bank.code} - ${bank.name}` : bankAccount.name.trim(),
        };
      });
    });
  }

  checkWindowSize() {
    this.isMobile = window.innerWidth <= 820;
  }

  setDefaultBankAccount(bankAccountId: number) {
    this.loading = true;

    this.bankAccountService.defaultAccount(bankAccountId).subscribe({
      next: (accountResult) => {
        this.loading = false;
        this.bankAccountService.updateBankAccountsView();

        this.notifier.notify('success', 'Conta padrão definida com sucesso.');
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  deleteBankAccount(bankAccountId: number) {
    this.loading = true;

    this.bankAccountService.deleteAccount(bankAccountId).subscribe({
      next: (accountResult) => {
        this.loading = false;
        this.bankAccountService.updateBankAccountsView();

        this.notifier.notify('success', 'Conta bancária excluída com sucesso.');
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  openAddBankAccountModal() {
    if (!this.isMobile) {
      this.modalService.present(AddBankAccountComponent);
    } else {
      this.bottomSheet.open(GenericBottomSheetComponent, {
        data: { content: this.bottomSheetContent },
      });
    }
  }
}
